var _path, _rect, _rect2, _path2, _rect3, _rect4, _rect5, _path3, _rect6, _path4, _rect7, _rect8, _rect9, _path5, _rect10, _path6, _path7, _rect11, _rect12, _rect13, _rect14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBonus2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H192V192H16C7.16344 192 0 184.837 0 176V16Z",
    fill: "#F9F9F9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 27,
    width: 145,
    height: 138.054,
    rx: 8.68263,
    fill: "url(#paint0_linear_5824_2474)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 119.994,
    y: 63.6503,
    width: 39.283,
    height: 89.3094,
    rx: 4.63356,
    fill: "#F9F9F9",
    stroke: "#CFCFCF",
    strokeWidth: 0.738161
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.625 103.303H159.646V148.327C159.646 151.089 157.406 153.329 154.644 153.329H124.628C121.865 153.329 119.625 151.089 119.625 148.327V103.303Z",
    fill: "#1EBEAB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 119.625,
    y: 123.938,
    width: 40.0212,
    height: 0.738161,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 119.625,
    y: 103.303,
    width: 40.0212,
    height: 0.738161,
    fill: "#CFCFCF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 119.625,
    y: 84.541,
    width: 40.0212,
    height: 0.738161,
    fill: "#CFCFCF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.221 136.156C133.849 136.156 133.548 135.858 133.548 135.489C133.548 135.121 133.849 134.822 134.221 134.822H145.381C145.753 134.822 146.054 135.121 146.054 135.489C146.054 135.858 145.753 136.156 145.381 136.156H134.221ZM145.381 137.713C145.753 137.713 146.054 138.011 146.054 138.38C146.054 138.748 145.753 139.047 145.381 139.047H134.221C133.849 139.047 133.548 138.748 133.548 138.38C133.548 138.011 133.849 137.713 134.221 137.713H145.381ZM145.381 140.603C145.753 140.603 146.054 140.902 146.054 141.27C146.054 141.639 145.753 141.937 145.381 141.937H134.221C133.849 141.937 133.548 141.639 133.548 141.27C133.548 140.902 133.849 140.603 134.221 140.603H145.381ZM145.381 143.494C145.753 143.494 146.054 143.792 146.054 144.161C146.054 144.529 145.753 144.828 145.381 144.828H134.221C133.849 144.828 133.548 144.529 133.548 144.161C133.548 143.792 133.849 143.494 134.221 143.494H145.381Z",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 76.5234,
    y: 63.6503,
    width: 39.283,
    height: 89.3094,
    rx: 4.63356,
    fill: "#F9F9F9",
    stroke: "#CFCFCF",
    strokeWidth: 0.738161
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1943 84.3066H116.134V147.897C116.134 150.66 113.895 152.899 111.132 152.899H81.197C78.4341 152.899 76.1943 150.66 76.1943 147.897V84.3066Z",
    fill: "#1EBEAB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 76.1543,
    y: 123.938,
    width: 40.0212,
    height: 0.738161,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 76.1543,
    y: 103.303,
    width: 40.0212,
    height: 0.738161,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 76.1543,
    y: 84.1602,
    width: 40.0212,
    height: 0.738161,
    fill: "#CFCFCF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.634 144.224V135.423C101.634 134.925 101.229 134.52 100.73 134.52H91.9297C91.4314 134.52 91.0259 134.925 91.0259 135.423V144.224C91.0259 144.722 91.4314 145.128 91.9297 145.128H100.73C101.229 145.128 101.634 144.722 101.634 144.224ZM100.73 133.57C101.752 133.57 102.583 134.402 102.583 135.423V144.224C102.583 145.246 101.752 146.077 100.73 146.077H91.9297C90.9079 146.077 90.0767 145.246 90.0767 144.224V135.423C90.0767 134.402 90.9079 133.57 91.9297 133.57H100.73ZM93.3279 137.272V136.513H99.2608V137.272H93.3279ZM93.3279 139.147V138.388H99.2608V139.147H93.3279ZM93.3279 141.022V140.263H99.2608V141.022H93.3279ZM93.3279 142.897V142.137H99.2608V142.897H93.3279Z",
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 33.0517,
    y: 63.6503,
    width: 39.283,
    height: 89.3094,
    rx: 4.63356,
    fill: "#F9F9F9",
    stroke: "#CFCFCF",
    strokeWidth: 0.738161
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7808 115.562H72.7209V147.895C72.7209 150.658 70.4811 152.898 67.7182 152.898H37.7834C35.0205 152.898 32.7808 150.658 32.7808 147.895V115.562Z",
    fill: "#1EBEAB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8541 134.822H50.8908L53.7706 143.475H51.9291L51.298 141.376H48.3894L47.7584 143.475H45.98L48.8541 134.822ZM49.8236 136.477L48.7624 140.021H50.9252L49.8637 136.477H49.8236ZM58.0907 141.118V140.651L56.7942 140.735C56.1689 140.783 55.8133 141.076 55.8133 141.532C55.8133 142.012 56.1918 142.312 56.7598 142.312C57.4883 142.312 58.0907 141.814 58.0907 141.118ZM54.1495 141.628C54.1495 140.459 55.01 139.781 56.5418 139.685L58.0907 139.589V139.164C58.0907 138.564 57.6891 138.216 57.0581 138.216C56.4328 138.216 56.0369 138.54 55.9566 139.014H54.4249C54.488 137.766 55.5033 136.909 57.1327 136.909C58.7103 136.909 59.7373 137.76 59.7373 139.056V143.475H58.1194V142.492H58.0849C57.7407 143.175 56.9777 143.577 56.209 143.577C55.0387 143.577 54.1495 142.785 54.1495 141.628Z",
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 131.781,
    y: 40.5791,
    width: 27.681,
    height: 10.7033,
    rx: 2.7681,
    fill: "black",
    stroke: "#9E9E9E",
    strokeWidth: 0.36908
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 98.5634,
    y: 40.5791,
    width: 27.681,
    height: 10.7033,
    rx: 2.7681,
    fill: "#313131",
    stroke: "#9E9E9E",
    strokeWidth: 0.36908
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 66.084,
    y: 40.5791,
    width: 27.681,
    height: 10.7033,
    rx: 2.7681,
    fill: "#EFCC93",
    stroke: "#9E9E9E",
    strokeWidth: 0.36908
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 33.0517,
    y: 40.7636,
    width: 27.312,
    height: 10.3343,
    rx: 2.58356,
    fill: "white",
    stroke: "#CFCFCF",
    strokeWidth: 0.738161
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5824_2474",
    x1: 96.5,
    y1: 27,
    x2: 96.5,
    y2: 165.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0DCE7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonus2);
export default __webpack_public_path__ + "static/media/bonus2.e1f7f28d2ef9fac74c4975236f7da23b.svg";
export { ForwardRef as ReactComponent };